import React from 'react';
import { isPlatform } from '@ionic/react';
import AppDownload from '../../../../components/AppDownload';


const Collection = (props:any) => {

    return (
        <>
            {(isPlatform("mobile")) && <AppDownload />}
        </>
    );
}

export default Collection;